import { SET_WEBCHAT_LOCATIONS } from '../actions/types';

export default function webchatLocationsReducer(state = [], action) {
	switch (action.type) {
		case SET_WEBCHAT_LOCATIONS:
			return action.payload || [];
		default:
			return state;
	}
}
